import SectionStepByStep from "apps/website/components/section/SectionStepByStep/SectionStepByStep";

export default function SectionHowItWorks() {
  return (
    <SectionStepByStep theme="light-grey" stepByStep={{ title: "How it works",
      options: {
        imageSize: "full-width",
      },
      steps: [
        {
          title: "Tell us about your cat",
          body: "We'll work out a personalised food plan based on their age, breed, activity levels and food preferences.",
          image: {
            src: "/images/dev/components/ImageTextList/1.webp",
            width: 327,
            height: 113,
          },
          spans: { xl: 3 },

        },
        {
          title: "We'll get cooking",
          body: "We'll prepare meals for your cat(s) by gently cooking their chosen recipes daily in our Suffolk kitchen.",
          image: {
            src: "/images/dev/components/ImageTextList/2.webp",
            width: 327,
            height: 113,
          },
          spans: { xl: 3 },
        },
        {
          title: "Get excited for delivery",
          body: <span>
            We&apos;ll send your 14-day trial box to start:
            <br />
            28 nutritionally-balanced fresh meat recipes your cat was born to eat.
          </span>,
          image: {
            src: "/images/dev/components/ImageTextList/3.webp",
            width: 327,
            height: 113,
          },
          spans: { xl: 3 },
        },
        {
          title: "See benefits in no time!",
          body: "From the first week, cat parents report  glossier coats, more energy and less mess in the litter tray. Happy days.",
          image: {
            src: "/images/dev/components/ImageTextList/4.webp",
            width: 327,
            height: 113,
          },
          spans: { xl: 3 },
        },
      ] }}/>
  );
}
